<template>
  <div class="reset">
    <h2>Forgotten your password?</h2>
    <p>To reset your password, enter your email address and mobile phone number below</p>
    <b-form class="w-50">
      <b-form-group label="Email">
        <b-form-input
          type="email"
          v-model="$v.email.$model"
          :class="{
            'is-valid': !$v.email.$error && email,
            'is-invalid': $v.email.$error && $v.email.$dirty
          }"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group label="Mobile number (If you registered with a non UK or Irish phone number please enter the phone number without the country code)">
        <b-form-input
          type="number"
          v-model="$v.phoneMob.$model"
          :class="{
            'is-valid': !$v.phoneMob.$error && phoneMob,
            'is-invalid': $v.phoneMob.$error && $v.phoneMob.$dirty
          }"
        >
        </b-form-input>
      </b-form-group>
      <b-alert v-if="error"
        show 
        variant="danger"
      >
        <p>{{ errorMsg }}</p>
      </b-alert>
      <b-alert v-if="success"
        show 
        variant="success"
      >
        <p>{{ successMsg }}</p>
      </b-alert>
      <b-form-group>
        <b-button
          variant="danger"
          @click="handleReset"
        >
          Reset Password
        </b-button>    
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { resetPassword } from '../services/api'
import { required, email } from 'vuelidate/lib/validators'
import { router } from '../router'
export default {
  data () {
    return {
      email: '',
      phoneMob: '',
      error: false,
      errorMsg: '',
      success: false,
      successMsg: ''
    }
  },
  methods: {
    async handleReset () {
      // Check form is valid
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const dataObj = {
          email: this.email,
          phoneMob: this.phoneMob
        }
        const res = await resetPassword(dataObj)
        if (res) {
          this.error = false
          this.success = true
          this.successMsg = 'A link has been sent to your email, please click the link to complete the password reset. You will now be taken back to the login page.'
          setTimeout(() => {
            this.success = false
            this.successMsg = ''
            router.push('/login')
          }, 8000)
        } else {
          this.error = true
          this.success = false
          this.errorMsg = 'There was an error resetting your password, please try again'
          setTimeout(() => {
            this.error = false
            this.errorMsg = ''
          }, 5000)
        }
      } else {
        this.error = true
        this.success = false
        this.errorMsg = 'Please complete all fields'
        setTimeout(() => {
          this.error = false
          this.errorMsg = ''
        }, 5000)
      }
    }
  },
  validations: {
    email: {
      required: required,
      email: email
    },
    phoneMob: {
      required: required
    }
  }
}
</script>

<style scoped>
.reset {
  height: 60vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>